// extracted by mini-css-extract-plugin
export var container = "blogPostInternalAd-module--container--fea63";
export var cta = "blogPostInternalAd-module--cta--74734";
export var heading = "blogPostInternalAd-module--heading--b1007";
export var image = "blogPostInternalAd-module--image--10384";
export var subheading = "blogPostInternalAd-module--subheading--9feb0";
export var text = "blogPostInternalAd-module--text--d1b05";